import { createQuery } from "react-query-kit";
import { API_END_POINT } from "../../constants";
import { getDataWithToken, getEndPoint } from "../../Utils/network.client";
import { AxiosError } from "axios";
import { Unions } from "../../models/transaction/purchase-model";

const url = getEndPoint(API_END_POINT.ORDER) + "/api/PurchaseInvoice/GetAllUnions";
export const useGetUnionPurchaseList = createQuery<
    Unions[],
    null,
    AxiosError
>({
    queryKey: ["keyUnionPurchaselist"],
    fetcher: (params) =>
        getDataWithToken<any>(url).then((response) => response.data?.result || console.log(response)),
        // axios.get(url, null).then((response) => response?.data?.result || console.log(response)),
    refetchOnWindowFocus: false,
});